<div class="container-fluid">
  <div class="row justify-content-center">
    <div class="col-xs-12 col-sm-10 col-md-8 col-xl-6">

      <h2 class="text-center">
        <fa-icon [icon]=faEnvelope></fa-icon> uitnodigen
      </h2>

      @if(!processing() && alert){
      <ngb-alert [type]="alert.type">{{ alert.message }}</ngb-alert>
      }

      @if(!processing()) {
        <form name="form" (ngSubmit)="false" [formGroup]="form" novalidate>
          <div class="form-group row">
            <label for="url" class="col-sm-2 col-form-label">link</label>
            <div class="col-sm-10">
              <input type="text" class="form-control" formControlName="url">
            </div>
          </div>
          <div class="form-group row mt-3 justify-content-end">
            <div class="col-10">
              <button ngxClipboard type="button" class="btn btn-primary btn-block" (cbOnSuccess)="showCopiedToClipboard()"
                [cbContent]=form.controls.url.value>
                <fa-icon [icon]=faClipboardCheck></fa-icon> de link kopieren naar het klembord
              </button>
            </div>
          </div>
        </form>
      } @else {
        <h2 class="text-center">
          <fa-icon [icon]=faSpinner [animation]="'spin'"></fa-icon>
        </h2>
      }
    </div>
  </div>
</div>

@if(!processing() && pool){
<app-pool-navbar [current]="Invite" [pool]="pool" [poolUser]="poolUserFromSession">
</app-pool-navbar>
}